import React from 'react';
import { MbmProvider } from '@amzn/react-arb-tools';
import arbManifest from 'translations/arbManifest';
import { getMbmOptions } from '../helpers';
import { SpacesProvider } from '../contexts';
import Dashboard from './Dashboard';

const mbmOptions = getMbmOptions(arbManifest);

/**
 * Root application component for Rufus Spaces
 *
 * Sets up the required providers and renders the main application.
 * The SpacesProvider manages global state for spaces.
 */
const App = () => {
    return (
        <MbmProvider {...mbmOptions}>
            <SpacesProvider>
                <div className="rufus-spaces-app">
                    <Dashboard />
                </div>
            </SpacesProvider>
        </MbmProvider>
    );
};

export default App;
